import {
    SiPython,
    SiCplusplus,
    SiC,
    SiR,
    SiJava,
    SiPytorch,
    SiKeras,
    SiTensorflow,
    SiPandas,
    SiNumpy,
    SiScikitlearn,
    SiOracle,
    SiVisualstudiocode,
    SiUbuntu,
    SiGithub,
    SiNvidia,
    SiPostgresql,
    SiMongodb,
    SiApachehive,
    SiApachespark,
    SiApachekafka,
    SiMicrosoftazure
} from "react-icons/si";
import {GrMysql,GrHadoop} from "react-icons/gr";
import {FaGitAlt} from "react-icons/fa";
import {VscTerminalBash} from "react-icons/vsc";

import React from "react";

const skillsConfig = {
    mainSkills: [
        {
            id: "skills-0",
            className: "skill-icon",
            icon: <SiPython size={50}/>,
            text: "Python"
        },
        {
            id: "skills-1",
            className: "skill-icon",
            icon: <SiR size={50}/>,
            text: "R"
        },
        {
            id: "skills-2",
            className: "skill-icon",
            icon: <SiC size={50}/>,
            text: "C"
        },
        {
            id: "skills-3",
            className: "skill-icon",
            icon: <SiCplusplus size={50}/>,
            text: "C++"
        },
        {
            id: "skills-4",
            className: "skill-icon",
            icon: <SiPytorch size={50}/>,
            text: "Pytorch"
        },
        {
            id: "skills-5",
            className: "skill-icon",
            icon: <SiPandas size={50}/>,
            text: "Pandas"
        },
        {
            id: "skills-6",
            className: "skill-icon",
            icon: <SiNumpy size={50}/>,
            text: "Numpy"
        },
        {
            id: "skills-7",
            className: "skill-icon",
            icon: <SiScikitlearn size={50}/>,
            text: "scikit-learn"
        },
        {
            id: "skills-17",
            className: "skill-icon",
            icon: <SiTensorflow size={50}/>,
            text: "Tensorflow"
        },
        {
            id: "skills-8",
            className: "skill-icon",
            icon: <GrMysql size={50}/>,
            text: "MySQL"
        },
        {
            id: "skills-9",
            className: "skill-icon",
            icon: <SiPostgresql size={50}/>,
            text: "PostgreSQL"
        },
        {
            id: "skills-10",
            className: "skill-icon",
            icon: <SiMongodb size={50}/>,
            text: "MongoDB"
        },
        {
            id: "skills-13",
            className: "skill-icon",
            icon: <SiApachekafka size={50}/>,
            text: "Apache Kafka"
        },
        {
            id: "skills-11",
            className: "skill-icon",
            icon: <SiApachehive size={50}/>,
            text: "Apache Hive"
        },
        {
            id: "skills-12",
            className: "skill-icon",
            icon: <SiApachespark size={50}/>,
            text: "Apache Spark"
        }
    ],
    complementarySkills: [
        {
            id: "skills-15",
            className: "skill-icon",
            icon: <SiJava size={50}/>,
            text: "Java"
        },
        {
            id: "skills-16",
            className: "skill-icon",
            icon: <SiKeras size={50}/>,
            text: "Keras"
        },
        {
            id: "skills-18",
            className: "skill-icon",
            icon: <GrHadoop size={50}/>,
            text: "Apache Hadoop"
        },
        {
            id: "skills-19",
            className: "skill-icon",
            icon: <SiNvidia size={50}/>,
            text: "CUDA"
        },
        {
            id: "skills-20",
            className: "skill-icon",
            icon: <SiOracle size={50}/>,
            text: "Oracle"
        },
        {
            id: "skills-25",
            className: "skill-icon",
            icon: <SiMicrosoftazure size={50}/>,
            text: "Azure"
        },
        {
            id: "skills-14",
            className: "skill-icon",
            icon: <FaGitAlt size={50}/>,
            text: "Git"
        },
        {
            id: "skills-21",
            className: "skill-icon",
            icon: <SiVisualstudiocode size={50}/>,
            text: "VS Code"
        },
        {
            id: "skills-22",
            className: "skill-icon",
            icon: <SiUbuntu size={50}/>,
            text: "Ubuntu"
        },
        {
            id: "skills-23",
            className: "skill-icon",
            icon: <SiGithub size={50}/>,
            text: "GitHub"
        },
        {
            id: "skills-24",
            className: "skill-icon",
            icon: <VscTerminalBash size={50}/>,
            text: "Shell script"
        }
    ]
}

export default skillsConfig
